import React from "react";
import HelpNavContainer from "./HelpNavContainer";
import HelpNavContent from "./HelpNavContent";
import ErrorBoundary from "../ErrorBoundary";

const SideNav = ({ currentTutorial, currentCategory, toc }) => {
  return (
    <ErrorBoundary>
      <HelpNavContainer>
          <HelpNavContent
            currentCategory={currentCategory}
            currentTutorial={currentTutorial}
            toc={toc}
          />
      </HelpNavContainer>
    </ErrorBoundary>
  );
};

export default SideNav;
